import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    if (this.getCookie("cookie_consent")) {
      this.bannerTarget.remove()
    } else {
      this.bannerTarget.hidden = false
    }
  }

  accept() {
    document.cookie = "cookie_consent=accepted; max-age=31536000; path=/; SameSite=Lax"
    this.bannerTarget.remove()
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
    return match ? match[1] : null
  }
}
